import React, { Component } from 'react';
import Pagination, { autoPerPage } from '../../components/Pagination';
import bg1Import from "../../images/background/optimized_clientssay.webp";
import testimonialsData from '../../data/testimonials_data.json';

const bg1 = typeof bg1Import === 'object' ? bg1Import.default : bg1Import;

class TestimonialSection extends Component {
  constructor(props) {
    super(props);
    this.state = { page: 1 };
  }

  handlePage = (page) => {
    this.setState({ page });
  };

  render() {
    const { page } = this.state;
    // fewer, cleaner cards per view
    const perPage = autoPerPage(3, 2, 1);
    const start = (page - 1) * perPage;
    const slice = testimonialsData.slice(start, start + perPage);
    const pages = Math.ceil(testimonialsData.length / perPage);

    return (
      <section
        className="section-area section-sp2 testimonial-area rr-section rr-section--testimonials"
        style={{
          ...(bg1 ? { backgroundImage: `url(${bg1})` } : {}),
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <div className="container">
          <div className="heading-bx text-center rr-section-header">
            <p className="rr-kicker">Trust</p>
            <h2 className="rr-headline">What Customers Say</h2>
            <p className="rr-subhead">Real feedback from riders and drivers who booked doorstep repairs.</p>
          </div>

          <div className="rr-testimonials-grid" style={{ gridTemplateColumns: `repeat(${perPage}, minmax(0, 1fr))` }}>
            {slice.map((item, idx) => (
              <article className="rr-testimonial-card" key={idx}>
                <div className="rr-quote">“</div>
                <p className="rr-testimonial-text">{item.text}</p>
                <div className="rr-testimonial-name">— {item.name}</div>
              </article>
            ))}
          </div>

          <Pagination page={page} pages={pages} onPage={this.handlePage} />
        </div>
      </section>
    );
  }
}

export default TestimonialSection;
